"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _EquipmentType = _interopRequireDefault(require("../model/EquipmentType"));
var _ForecastRange = _interopRequireDefault(require("../model/ForecastRange"));
var _MarketCompositePricingResponse = _interopRequireDefault(require("../model/MarketCompositePricingResponse"));
var _MarketForecastResponse = _interopRequireDefault(require("../model/MarketForecastResponse"));
var _MyCarriersResponse = _interopRequireDefault(require("../model/MyCarriersResponse"));
var _MyPriceForecastResponse = _interopRequireDefault(require("../model/MyPriceForecastResponse"));
var _MyPriceResponse = _interopRequireDefault(require("../model/MyPriceResponse"));
var _ShipmentType = _interopRequireDefault(require("../model/ShipmentType"));
var _ShipwellApiErrorResponse = _interopRequireDefault(require("../model/ShipwellApiErrorResponse"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * Shipwell Pricing API
                                                                                                                                                                                                                                                                                                                                                                                               * Historical & forecasted shipping lane price data, at your fingertips.
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               * The version of the OpenAPI document: 0.9.1
                                                                                                                                                                                                                                                                                                                                                                                               * 
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
                                                                                                                                                                                                                                                                                                                                                                                               * https://openapi-generator.tech
                                                                                                                                                                                                                                                                                                                                                                                               * Do not edit the class manually.
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               */
/**
* Public service.
* @module api/PublicApi
* @version 0.9.1
*/
var PublicApi = /*#__PURE__*/function () {
  /**
  * Constructs a new PublicApi. 
  * @alias module:api/PublicApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function PublicApi(apiClient) {
    _classCallCheck(this, PublicApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Callback function to receive the result of the getHistoricalMarketPricingHistoricalMarketGet operation.
   * @callback module:api/PublicApi~getHistoricalMarketPricingHistoricalMarketGetCallback
   * @param {String} error Error message, if any.
   * @param {module:model/MarketCompositePricingResponse} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get Historical Market Pricing
   * Attempts to retrieve shipping lane Shipwell Market Composite Data, and then returns the retrieved prices to the caller.  - **equipment_type**: Equipment type the lane was run with - `DRY_VAN`, `REEFER` or `FLATBED`  - **stops**: List of stops in the format, that compose the shipping lane `country:US|state_province:TX|postal_code:78701`.
   * @param {module:model/EquipmentType} equipmentType 
   * @param {Array.<String>} stops List of stops in the format `country:US|state_province:TX|postal_code:78701`
   * @param {module:api/PublicApi~getHistoricalMarketPricingHistoricalMarketGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/MarketCompositePricingResponse}
   */
  _createClass(PublicApi, [{
    key: "getHistoricalMarketPricingHistoricalMarketGet",
    value: function getHistoricalMarketPricingHistoricalMarketGet(equipmentType, stops, callback) {
      var postBody = null;
      // verify the required parameter 'equipmentType' is set
      if (equipmentType === undefined || equipmentType === null) {
        throw new Error("Missing the required parameter 'equipmentType' when calling getHistoricalMarketPricingHistoricalMarketGet");
      }
      // verify the required parameter 'stops' is set
      if (stops === undefined || stops === null) {
        throw new Error("Missing the required parameter 'stops' when calling getHistoricalMarketPricingHistoricalMarketGet");
      }
      var pathParams = {};
      var queryParams = {
        'equipment_type': equipmentType,
        'stops': this.apiClient.buildCollectionParam(stops, 'multi')
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['APIKeyHeader'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _MarketCompositePricingResponse["default"];
      return this.apiClient.callApi('/historical/market', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getMarketForecastPricingForecastMarketGet operation.
     * @callback module:api/PublicApi~getMarketForecastPricingForecastMarketGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MarketForecastResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Market Forecast Pricing
     * Attempts to forecast today's price using historical market data. Historical Data: - SONAR (via FreightWaves)  - **forecast_range**: Length of forecast, begging on current day - `1 day`, `14 day`, `1 month`, or `3 month`  - **equipment_type**: Equipment type the lane was run with - `DRY_VAN`, `REEFER` or `FLATBED`  - **stops**: List of stops in the format, that compose the shipping lane `country:US|state_province:TX|postal_code:78701`.
     * @param {module:model/EquipmentType} equipmentType 
     * @param {Array.<String>} stops List of stops in the format `country:US|state_province:TX|postal_code:78701`
     * @param {module:model/ForecastRange} forecastRange 
     * @param {module:api/PublicApi~getMarketForecastPricingForecastMarketGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MarketForecastResponse}
     */
  }, {
    key: "getMarketForecastPricingForecastMarketGet",
    value: function getMarketForecastPricingForecastMarketGet(equipmentType, stops, forecastRange, callback) {
      var postBody = null;
      // verify the required parameter 'equipmentType' is set
      if (equipmentType === undefined || equipmentType === null) {
        throw new Error("Missing the required parameter 'equipmentType' when calling getMarketForecastPricingForecastMarketGet");
      }
      // verify the required parameter 'stops' is set
      if (stops === undefined || stops === null) {
        throw new Error("Missing the required parameter 'stops' when calling getMarketForecastPricingForecastMarketGet");
      }
      // verify the required parameter 'forecastRange' is set
      if (forecastRange === undefined || forecastRange === null) {
        throw new Error("Missing the required parameter 'forecastRange' when calling getMarketForecastPricingForecastMarketGet");
      }
      var pathParams = {};
      var queryParams = {
        'equipment_type': equipmentType,
        'stops': this.apiClient.buildCollectionParam(stops, 'multi'),
        'forecast_range': forecastRange
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['APIKeyHeader'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _MarketForecastResponse["default"];
      return this.apiClient.callApi('/forecast/market', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getMyCarriersPriceHistoricalCarrierGet operation.
     * @callback module:api/PublicApi~getMyCarriersPriceHistoricalCarrierGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MyCarriersResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get My Carriers Price
     * Retrieves carrier lane price data for an individual company and returns the retrieved prices to the caller.  - **equipment_type**: Equipment type the lane was run with - `DRY_VAN`, `REEFER` or `FLATBED`  - **stops**: List of stops in the format `country:US|state_province:TX|postal_code:78701`
     * @param {module:model/EquipmentType} equipmentType 
     * @param {Array.<String>} stops List of stops in the format `country:US|state_province:TX|postal_code:78701`
     * @param {Number} pickupRadius 
     * @param {Number} dropOffRadius 
     * @param {Object} opts Optional parameters
     * @param {module:model/ShipmentType} [shipmentType] 
     * @param {Date} [pickupDateGte] 
     * @param {String} [filter] Comma delimited list of fields, operators and values to filter on
     * @param {String} [sort] 
     * @param {Number} [page = 1)] 
     * @param {Number} [limit = 50)] 
     * @param {module:api/PublicApi~getMyCarriersPriceHistoricalCarrierGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MyCarriersResponse}
     */
  }, {
    key: "getMyCarriersPriceHistoricalCarrierGet",
    value: function getMyCarriersPriceHistoricalCarrierGet(equipmentType, stops, pickupRadius, dropOffRadius, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'equipmentType' is set
      if (equipmentType === undefined || equipmentType === null) {
        throw new Error("Missing the required parameter 'equipmentType' when calling getMyCarriersPriceHistoricalCarrierGet");
      }
      // verify the required parameter 'stops' is set
      if (stops === undefined || stops === null) {
        throw new Error("Missing the required parameter 'stops' when calling getMyCarriersPriceHistoricalCarrierGet");
      }
      // verify the required parameter 'pickupRadius' is set
      if (pickupRadius === undefined || pickupRadius === null) {
        throw new Error("Missing the required parameter 'pickupRadius' when calling getMyCarriersPriceHistoricalCarrierGet");
      }
      // verify the required parameter 'dropOffRadius' is set
      if (dropOffRadius === undefined || dropOffRadius === null) {
        throw new Error("Missing the required parameter 'dropOffRadius' when calling getMyCarriersPriceHistoricalCarrierGet");
      }
      var pathParams = {};
      var queryParams = {
        'equipment_type': equipmentType,
        'stops': this.apiClient.buildCollectionParam(stops, 'multi'),
        'pickup_radius': pickupRadius,
        'drop_off_radius': dropOffRadius,
        'shipment_type': opts['shipmentType'],
        'pickup_date.gte': opts['pickupDateGte'],
        'filter': opts['filter'],
        'sort': opts['sort'],
        'page': opts['page'],
        'limit': opts['limit']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['APIKeyHeader'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _MyCarriersResponse["default"];
      return this.apiClient.callApi('/historical_carrier', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getMyPriceExportHistoricalExportGet operation.
     * @callback module:api/PublicApi~getMyPriceExportHistoricalExportGetCallback
     * @param {String} error Error message, if any.
     * @param {Object} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get My Price Export
     * Exports shipping lane price data for an individual company/lane into a CSV.  - **equipment_type**: Equipment type the lane was run with - `DRY_VAN`, `REEFER` or `FLATBED`  - **stops**: List of stops in the format `country:US|state_province:TX|postal_code:78701`
     * @param {module:model/EquipmentType} equipmentType 
     * @param {Array.<String>} stops List of stops in the format `country:US|state_province:TX|postal_code:78701`
     * @param {Number} pickupRadius 
     * @param {Number} dropOffRadius 
     * @param {Object} opts Optional parameters
     * @param {module:model/ShipmentType} [shipmentType] 
     * @param {Date} [pickupDateGte] 
     * @param {String} [filter] Comma delimited list of fields, operators and values to filter on
     * @param {String} [sort] 
     * @param {module:api/PublicApi~getMyPriceExportHistoricalExportGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Object}
     */
  }, {
    key: "getMyPriceExportHistoricalExportGet",
    value: function getMyPriceExportHistoricalExportGet(equipmentType, stops, pickupRadius, dropOffRadius, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'equipmentType' is set
      if (equipmentType === undefined || equipmentType === null) {
        throw new Error("Missing the required parameter 'equipmentType' when calling getMyPriceExportHistoricalExportGet");
      }
      // verify the required parameter 'stops' is set
      if (stops === undefined || stops === null) {
        throw new Error("Missing the required parameter 'stops' when calling getMyPriceExportHistoricalExportGet");
      }
      // verify the required parameter 'pickupRadius' is set
      if (pickupRadius === undefined || pickupRadius === null) {
        throw new Error("Missing the required parameter 'pickupRadius' when calling getMyPriceExportHistoricalExportGet");
      }
      // verify the required parameter 'dropOffRadius' is set
      if (dropOffRadius === undefined || dropOffRadius === null) {
        throw new Error("Missing the required parameter 'dropOffRadius' when calling getMyPriceExportHistoricalExportGet");
      }
      var pathParams = {};
      var queryParams = {
        'equipment_type': equipmentType,
        'stops': this.apiClient.buildCollectionParam(stops, 'multi'),
        'pickup_radius': pickupRadius,
        'drop_off_radius': dropOffRadius,
        'shipment_type': opts['shipmentType'],
        'pickup_date.gte': opts['pickupDateGte'],
        'filter': opts['filter'],
        'sort': opts['sort']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['APIKeyHeader'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/historical/export', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getMyPriceForecastForecastGet operation.
     * @callback module:api/PublicApi~getMyPriceForecastForecastGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MyPriceForecastResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get My Price Forecast
     * Forecasts a shipping lane price.  - **equipment_type**: Equipment type the lane was run with - `DRY_VAN`, `REEFER` or `FLATBED`  - **stops**: List of stops in the format `country:US|state_province:TX|postal_code:78701`  - **pickup_date**: Enter planned pickup date for your shipment  `2021-02-03`.  - **description**: Total-to-truck forecasted price.
     * @param {module:model/EquipmentType} equipmentType 
     * @param {Array.<String>} stops List of stops in the format `country:US|state_province:TX|postal_code:78701`
     * @param {Object} opts Optional parameters
     * @param {Date} [pickupDate] 
     * @param {module:api/PublicApi~getMyPriceForecastForecastGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MyPriceForecastResponse}
     */
  }, {
    key: "getMyPriceForecastForecastGet",
    value: function getMyPriceForecastForecastGet(equipmentType, stops, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'equipmentType' is set
      if (equipmentType === undefined || equipmentType === null) {
        throw new Error("Missing the required parameter 'equipmentType' when calling getMyPriceForecastForecastGet");
      }
      // verify the required parameter 'stops' is set
      if (stops === undefined || stops === null) {
        throw new Error("Missing the required parameter 'stops' when calling getMyPriceForecastForecastGet");
      }
      var pathParams = {};
      var queryParams = {
        'equipment_type': equipmentType,
        'stops': this.apiClient.buildCollectionParam(stops, 'multi'),
        'pickup_date': opts['pickupDate']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['APIKeyHeader'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _MyPriceForecastResponse["default"];
      return this.apiClient.callApi('/forecast', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getMyPriceHistoricalGet operation.
     * @callback module:api/PublicApi~getMyPriceHistoricalGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MyPriceResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get My Price
     * Retrieves shipping lane price data for an individual company and returns the retrieved prices to the caller.  - **equipment_type**: Equipment type the lane was run with - `DRY_VAN`, `REEFER` or `FLATBED`  - **stops**: List of stops in the format `country:US|state_province:TX|postal_code:78701`
     * @param {module:model/EquipmentType} equipmentType 
     * @param {Array.<String>} stops List of stops in the format `country:US|state_province:TX|postal_code:78701`
     * @param {Number} pickupRadius 
     * @param {Number} dropOffRadius 
     * @param {Object} opts Optional parameters
     * @param {module:model/ShipmentType} [shipmentType] 
     * @param {Date} [pickupDateGte] 
     * @param {String} [filter] Comma delimited list of fields, operators and values to filter on
     * @param {String} [sort] 
     * @param {Number} [page = 1)] 
     * @param {Number} [limit = 50)] 
     * @param {module:api/PublicApi~getMyPriceHistoricalGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MyPriceResponse}
     */
  }, {
    key: "getMyPriceHistoricalGet",
    value: function getMyPriceHistoricalGet(equipmentType, stops, pickupRadius, dropOffRadius, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'equipmentType' is set
      if (equipmentType === undefined || equipmentType === null) {
        throw new Error("Missing the required parameter 'equipmentType' when calling getMyPriceHistoricalGet");
      }
      // verify the required parameter 'stops' is set
      if (stops === undefined || stops === null) {
        throw new Error("Missing the required parameter 'stops' when calling getMyPriceHistoricalGet");
      }
      // verify the required parameter 'pickupRadius' is set
      if (pickupRadius === undefined || pickupRadius === null) {
        throw new Error("Missing the required parameter 'pickupRadius' when calling getMyPriceHistoricalGet");
      }
      // verify the required parameter 'dropOffRadius' is set
      if (dropOffRadius === undefined || dropOffRadius === null) {
        throw new Error("Missing the required parameter 'dropOffRadius' when calling getMyPriceHistoricalGet");
      }
      var pathParams = {};
      var queryParams = {
        'equipment_type': equipmentType,
        'stops': this.apiClient.buildCollectionParam(stops, 'multi'),
        'pickup_radius': pickupRadius,
        'drop_off_radius': dropOffRadius,
        'shipment_type': opts['shipmentType'],
        'pickup_date.gte': opts['pickupDateGte'],
        'filter': opts['filter'],
        'sort': opts['sort'],
        'page': opts['page'],
        'limit': opts['limit']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['APIKeyHeader'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _MyPriceResponse["default"];
      return this.apiClient.callApi('/historical', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getMyPriceMlForecastMlForecastGet operation.
     * @callback module:api/PublicApi~getMyPriceMlForecastMlForecastGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MyPriceForecastResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get My Price Ml Forecast
     * Forecasts a shipping lane price using a machine learning model.  - **equipment_type**: Equipment type the lane was run with - `DRY_VAN`, `REEFER` or `FLATBED`  - **stops**: List of stops in the format `country:US|state_province:TX|postal_code:78701`  - **pickup_date**: Enter planned pickup date for your shipment  `2021-02-03`.  - **description**: Total-to-truck forecasted price.
     * @param {module:model/EquipmentType} equipmentType 
     * @param {Array.<String>} stops List of stops in the format `country:US|state_province:TX|postal_code:78701`
     * @param {Object} opts Optional parameters
     * @param {Date} [pickupDate] 
     * @param {module:api/PublicApi~getMyPriceMlForecastMlForecastGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MyPriceForecastResponse}
     */
  }, {
    key: "getMyPriceMlForecastMlForecastGet",
    value: function getMyPriceMlForecastMlForecastGet(equipmentType, stops, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'equipmentType' is set
      if (equipmentType === undefined || equipmentType === null) {
        throw new Error("Missing the required parameter 'equipmentType' when calling getMyPriceMlForecastMlForecastGet");
      }
      // verify the required parameter 'stops' is set
      if (stops === undefined || stops === null) {
        throw new Error("Missing the required parameter 'stops' when calling getMyPriceMlForecastMlForecastGet");
      }
      var pathParams = {};
      var queryParams = {
        'equipment_type': equipmentType,
        'stops': this.apiClient.buildCollectionParam(stops, 'multi'),
        'pickup_date': opts['pickupDate']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['APIKeyHeader'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _MyPriceForecastResponse["default"];
      return this.apiClient.callApi('/ml_forecast', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);
  return PublicApi;
}();
exports["default"] = PublicApi;